import ExpandableSection from "../Components/Standalones/ExpandableSection";
import Header from "../Components/Parent/Header";
import { makeStyles } from "@material-ui/core/styles";
import setStyles from "../setStyles";
import AllUsers from "../Components/Standalones/AllUsers";

const Spouse = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Header headingText="Spouse Menu" />
      <ExpandableSection placeholder="My Spouse">
        <AllUsers selected={true} fullWidth={true} />
      </ExpandableSection>
      <ExpandableSection placeholder="All Players">
        <AllUsers fullWidth={true} />
      </ExpandableSection>
    </div>
  );
};

export default Spouse;

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: setStyles.maxWidth,
    margin: "110px auto auto",
  },
}));
